const isBrowser = typeof window !== "undefined"

export const get_y_coords = (selector, offset = 0) => {
  if (!isBrowser) {
    return 0
  }

  const elem = document.querySelector(selector)
  
  if (elem === null) {
    window.location.assign(window.location.origin + '/' + selector)
    return
  }

  return (elem.getBoundingClientRect().top + offset)
}

export const scroll_to = (y) => {
  if (!isBrowser) {
    return
  }

  if (typeof y === 'string') {
    y = get_y_coords(y)
  }

  window.scrollTo({
    top: y,
    behavior: 'smooth'
  })
}

export const scroll_top = () => {
  if (!isBrowser) {
    return 
  }

  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
